import { Trans } from '@lingui/macro';
import React, { FunctionComponent, useState } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import { isGettyClient } from '@helpers/getty-strings';

import classes from './styles/brandguide-announcement.module.scss';

export const BrandguideAnnouncement: FunctionComponent = () => {
  const key = 'bf-boulder-brandguide-v2-announcement-round-3';

  const [show, setShow] = useState(localStorage.getItem(key) === 'false' ? false : true);

  const handleDismiss = (): void => {
    setShow(false);
    localStorage.setItem(key, 'false');
  };

  if (!show) return null;

  const href = isGettyClient()
    ? 'https://damhelp.gettyimages.com/en/article/brandguide-tutorial'
    : 'https://help.brandfolder.com/hc/en-us/articles/12052930317463';

  return (
    <I18nProviderWrapper>
      <div className={classes.brandguideAnnouncement}>
        <p className={classes.brandguideAnnouncementText}>
          <Trans>
            <span aria-hidden role="img">⚠️</span> Action Required <span aria-hidden role="img">⚠️</span>{' '}
            <a
              className={classes.brandguideAnnouncementLink}
              href={href}
              rel="noreferrer"
              target="_blank"
            >
              Move your Brandguide
            </a>{' '}to the newest experience today!
          </Trans>
        </p>
        <button
          className={classes.brandguideAnnouncementButton}
          onClick={(): void => handleDismiss()}
          type="button">
            x
        </button>
      </div>
    </I18nProviderWrapper>
  );
};
